import { QueryClient } from "@tanstack/react-query";
import { client as avelaAiClient } from "src/generated/hooks/avela-ai/requests/services.gen";
import { client as publicFormServiceClient } from "src/generated/hooks/form-service-public/requests/services.gen";
import { client as formServiceClient } from "src/generated/hooks/form-service/requests/services.gen";
import { client as orgConfigClient } from "src/generated/hooks/org-config/requests/services.gen";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

export function createAuthenticatedQueryClient(
  accessToken: string,
  formServiceBaseUrl: string,
  avelaServicesBaseUrl: string
) {
  // Configure the form-service REST client with auth headers
  formServiceClient.setConfig({
    baseUrl: `${formServiceBaseUrl}/v1`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    throwOnError: true,
  });

  // Configure the avela-ai REST client with auth headers
  avelaAiClient.setConfig({
    baseUrl: avelaServicesBaseUrl,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    throwOnError: true,
  });

  return queryClient;
}

export function createUnauthenticatedQueryClient(
  orgConfigUrl: string,
  formServiceBaseUrl: string
) {
  orgConfigClient.setConfig({
    baseUrl: `${orgConfigUrl}/organization/v1`,
  });
  publicFormServiceClient.setConfig({
    baseUrl: `${formServiceBaseUrl}/public/v1`,
    throwOnError: true,
  });

  return queryClient;
}

// To enable TanStack Query Dev tool
declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: import("@tanstack/query-core").QueryClient;
  }
}
window.__TANSTACK_QUERY_CLIENT__ = queryClient;
